import React from 'react';
import { Helmet } from 'react-helmet';
import Layout from '@/components/Layout';
import LoftInsulationPage from '@/components/loft-insulation/LoftInsulationPage';

const LoftInsulation = () => {
  return (
    <>
      <Helmet>
        <title>EPC Builder</title>
        <meta
          name="description"
          content="Improving your property's value, efficiency, and running costs with home upgrades"
        />
      </Helmet>
      <Layout title="EPC Builder Loft Insulation">
        <LoftInsulationPage />
      </Layout>
    </>
  );
};

export default LoftInsulation;
